import React from 'react';
import { RefreshCw } from 'lucide-react';

export function UpdateBanner({ onUpdate }) {
  if (!onUpdate) return null;

  const handleUpdate = () => {
    onUpdate();
    window.location.reload();
  };

  return (
    <div
      data-testid="update-banner"
      className="fixed top-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-[340px] z-[60] bg-white rounded-2xl shadow-xl border border-gray-100 p-4 flex items-center gap-3 animate-in slide-in-from-top-4"
    >
      <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0">
        <RefreshCw className="w-5 h-5 text-blue-600" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900">Update available</p>
        <p className="text-xs text-gray-500">Tap to get the latest version</p>
      </div>
      <button
        onClick={handleUpdate}
        data-testid="update-banner-refresh"
        className="px-3 py-1.5 text-xs font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex-shrink-0"
      >
        Update
      </button>
    </div>
  );
}
